import React from "react";
import Row from "@amzn/meridian/row";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import { EditDatesTable } from "./EditDatesTable";

interface IDatesModalProps {
    data: any;
    handleInputChange: any;
    open: boolean;
    setOpen: any;
}

export const DatesModal: React.FC<IDatesModalProps> = ({
    data,
    handleInputChange,
    open,
    setOpen,
}) => (
    <Modal
        title="Important Dates"
        open={open}
        onClose={() => setOpen(false)}
        scrollContainer="viewport"
        closeLabel="Close"
        aria-describedby="modal-description"
    >
        <EditDatesTable data={data} handleInputChange={handleInputChange} />
        <ModalFooter>
            <Row alignmentHorizontal="end" widths="fit" />
        </ModalFooter>
    </Modal>
);
